import _ from 'lodash';
import { t, Trans } from '@lingui/macro';
import { Box, Typography } from '@material-ui/core';
import FormSection from '../../form/FormSection';
import ListFormField from '../../form/ListFormField';
import { IP_RULE_FIELD } from '../../ip-form/IpFormConstants';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { getSnmpTableColumns, NOTIFICATIONS_SNMPTRAPSENDTO_FIELD } from './NotificationPolicyConstants';
import EditSnmpTrapForm from './EditSnmpTrapForm';
import { usePlmId } from '../../../utilities/PgmUtilities';
import { useSettingStyles } from './NotificationPolicySettingsStyles';

const addButtonText = t`Add SNMP Trap`;
const noSnmpTrapText = t`Click the Add SNMP Trap button above to add a new SNMP Trap notification`;
const initialSortRules = [{ property: IP_RULE_FIELD, direction: SORT_ASC }];

const useMibFileUrl = () => {
    const MIB_FILE_URL = '/nGeniusPulse.mib';
    const plmId = usePlmId();
    const prefix = plmId ? `/plm/${plmId}` : '';
    return `${prefix}${MIB_FILE_URL}`;
};

export default function SnmpNotifications(props) {
    const { notification, setSnmpTrapSelectionIsDirty, selectedType } = props;
    const classes = useSettingStyles();
    const mibFileUrl = useMibFileUrl();

    if (_.isEmpty(notification)) {
        return null;
    }

    return (
        <FormSection title={t`SNMP Notifications`} addSpacer>
            <ListFormField
                fieldName={NOTIFICATIONS_SNMPTRAPSENDTO_FIELD}
                dbSelected={_.get(notification, NOTIFICATIONS_SNMPTRAPSENDTO_FIELD)}
                addButtonText={addButtonText}
                gridColumns={getSnmpTableColumns(selectedType)}
                emptyGridText={noSnmpTrapText}
                formComponent={<EditSnmpTrapForm selectedType={selectedType} />}
                selectedListSorter={initialSortRules}
                setSelectionIsDirty={setSnmpTrapSelectionIsDirty}
                showGridToolbar
                showSearch
                visibleRows={8}
            />
            <Box mt={1.5} mb={2}>
                <Typography className={classes.mibField} variant="caption" gutterBottom>
                    <Trans>Download</Trans>{' '}
                    <a target="_blank" rel="noreferrer" href={mibFileUrl}>
                        SNMP MIB file
                    </a>{' '}
                    <Trans>for Trap definition</Trans>
                </Typography>
            </Box>
        </FormSection>
    );
}
